import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetSearchItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetSearchItemListForModalController.php
* @route '/api/search-item-for-modal'
*/
const GetSearchItemListForModalController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSearchItemListForModalController.url(options),
    method: 'get',
})

GetSearchItemListForModalController.definition = {
    methods: ["get","head"],
    url: '/api/search-item-for-modal',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetSearchItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetSearchItemListForModalController.php
* @route '/api/search-item-for-modal'
*/
GetSearchItemListForModalController.url = (options?: RouteQueryOptions) => {
    return GetSearchItemListForModalController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetSearchItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetSearchItemListForModalController.php
* @route '/api/search-item-for-modal'
*/
GetSearchItemListForModalController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSearchItemListForModalController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetSearchItemListForModalController::__invoke
* @see app/Http/Controllers/Item/GetSearchItemListForModalController.php
* @route '/api/search-item-for-modal'
*/
GetSearchItemListForModalController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSearchItemListForModalController.url(options),
    method: 'head',
})

export default GetSearchItemListForModalController